import Vue from 'vue';
import App from './App.vue';
import router from './router';

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPlus, faTrashAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faCheck);
library.add(faPlus);
library.add(faTrashAlt);
library.add(faTimes);

Vue.component('font-awesome-icon', FontAwesomeIcon);

import VueResource from 'vue-resource';
import moment from 'moment';
import * as DateUtils from '@/utils/dateUtils';

Vue.component('font-awesome-icon', FontAwesomeIcon);
moment.locale('it');

Vue.use(VueResource);
Vue.use(BootstrapVue);
Vue.config.productionTip = false;
Vue.filter('formatDate', (value: any) => {
  if (value) {
    if (value.toString().indexOf('9999') !== -1 || value.toString().indexOf('2118') !== -1) {
      return '';
    } else {
      return moment(String(value)).format('DD/MM/YYYY');
    }
  }
});

Vue.filter('formatDateArray', (dateArray: Array<number>) => {
  if (dateArray && dateArray.length === 3) {
    return moment(String(DateUtils.arrayToDate(dateArray))).format('DD/MM/YYYY');
  } else {
    return '-';
  }
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
